import request from '@/utils/request';

export function queryUserCommissionWithdrawalApplyLogPageList(data) {
  return request({
    url: '/user/commission/withdrawal/apply/queryUserCommissionWithdrawalApplyLogPageList',
    method: 'POST',
    data
  });
}
// 提现审核
export function updateUserCommissionWithdrawalApplyLog(data) {
  return request({
    url: '/user/commission/withdrawal/apply/updateUserCommissionWithdrawalApplyLog',
    method: 'POST',
    data
  });
}
// 上传凭证
export function uploadPaymentImage(data) {
  return request({
    url: '/user/commission/withdrawal/apply/uploadPaymentImage',
    method: 'POST',
    data
  });
}
// 数量
export function queryUserCommissionWithdrawalApplyLogCount(data) {
  return request({
    url: '/user/commission/withdrawal/apply/queryUserCommissionWithdrawalApplyLogCount',
    method: 'POST',
    data
  });
}
// 导出Excel
export function exportExcel(data) {
  return request({
    url: '/user/commission/withdrawal/apply/exportUserCommissionWithdrawalApplyLogToExcel',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/finance.js